import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React, { Component } from 'react';

export class Infraction extends Component {
    render() {
        const { description, manquement, article, montant, date } = this.props.infraction;
        const urlArticle = 'Article/' + manquement;

        return (
            <TableRow hover={false}>
                <TableCell>{description}</TableCell>
                <TableCell><a href={urlArticle} target='_blank' rel='noopener noreferrer' >{article}</a></TableCell>
                <TableCell align="right" className='insecable'><span>{montant} $</span></TableCell>
                <TableCell>{date}</TableCell>
            </TableRow>
        );
    }
}
